import { Component } from '@angular/core';
import { ExportsPanelService, IExportListItem } from '@irb-common/modules/main-menu/exports-panel/exports-panel.service';
import { IrbAgGridExportService } from '@irb/irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service';

@Component({ standalone: false,
  selector: 'irb-exports-panel',
  templateUrl: './exports-panel.component.html',
  styleUrls: ['./exports-panel.component.scss']
})
export class ExportsPanelComponent {
  isLoading: boolean = true;
  data: Array<IExportListItem> = [];

  constructor(private eps: ExportsPanelService, private ges: IrbAgGridExportService) { }

  onShow() {
    this.getList();
  }

  getList() {
    this.isLoading = true;

    this.eps.getList().subscribe((res: Array<IExportListItem>) => {
      this.isLoading = false;
      this.data = res;
    });
  }

  download(exportId: string) {
    let f = this.data.find((x: IExportListItem) => x.exportId.toString() == exportId);
    
    if(f) {
      this.eps.download(exportId).subscribe((res: any) => {
        this.ges.setFileName(f.displayFileName);
        this.ges.download(res);
      });
    }
  }
}
